import $ from 'jquery';
import { showLoading, hideLoading } from './utils';

var SavedSearches = {
  bind: function() {
    $('.search-action')
      .off('click')
      .on('click', this.confirmAction);
  },

  confirmAction: function(e) {
    e.preventDefault();

    var proceed = confirm('Are you sure you would like to ' + $(this).html().toLowerCase() + '?');

    if(proceed) {
      showLoading();
      $.get($(this).attr('href'), SavedSearches.replaceContent);
      hideLoading();
    }
  },

  replaceContent: function(content) {
    $('#main_column').html(content);
    SavedSearches.bind();
  }
};

export default SavedSearches;



// WEBPACK FOOTER //
// ./app/webroot/javascript/modules/saved_searches.js